import { computed, Injectable, signal } from '@angular/core';
import { IServico } from '@nomoh-monorepo/shared-types';

/**
 * Data Service para Servico - Gestão de estado com Signals
 */
@Injectable({
  providedIn: 'root',
})
export class ServicoDataService {
  // State privado
  private _servicos = signal<IServico[]>([]);
  private _servicoAtual = signal<IServico | null>(null);
  private _loading = signal(false);
  private _erro = signal<string | null>(null);

  // Signals públicos (readonly)
  $servicos = this._servicos.asReadonly();
  $servicoAtual = this._servicoAtual.asReadonly();
  $loading = this._loading.asReadonly();
  $erro = this._erro.asReadonly();

  // Computed signals
  $servicosAtivos = computed(() =>
    this._servicos().filter((s) => s.status === true)
  );

  $servicosPorTipo = computed(() => {
    const servicos = this._servicos();
    const porTipo = new Map<string, IServico[]>();

    servicos.forEach((servico) => {
      const lista = porTipo.get(servico.tipoServicoId) || [];
      lista.push(servico);
      porTipo.set(servico.tipoServicoId, lista);
    });

    return porTipo;
  });

  $totalServicos = computed(() => this._servicos().length);

  // Setters
  setServicos(servicos: IServico[]) {
    this._servicos.set(this.normalizarServicos(servicos));
  }

  setServicoAtual(servico: IServico | null) {
    this._servicoAtual.set(servico);
  }

  addServico(servico: IServico) {
    this._servicos.update((current) =>
      this.normalizarServicos([...current, servico])
    );
  }

  updateServico(id: string, data: Partial<IServico>) {
    this._servicos.update((current) =>
      this.normalizarServicos(
        current.map((s) => (s.id === id ? { ...s, ...data } : s))
      )
    );

    if (this._servicoAtual()?.id === id) {
      this._servicoAtual.update((current) =>
        current ? { ...current, ...data } : null
      );
    }
  }

  removeServico(id: string) {
    this._servicos.update((current) =>
      this.normalizarServicos(current.filter((s) => s.id !== id))
    );

    if (this._servicoAtual()?.id === id) {
      this._servicoAtual.set(null);
    }
  }

  setLoading(loading: boolean) {
    this._loading.set(loading);
  }

  setErro(erro: string | null) {
    this._erro.set(erro);
  }

  limparErro() {
    this._erro.set(null);
  }

  limpar() {
    this._servicos.set([]);
    this._servicoAtual.set(null);
    this._loading.set(false);
    this._erro.set(null);
  }

  private normalizarServicos(servicos: IServico[]): IServico[] {
    return [...(servicos || [])].sort((a, b) => a.nome.localeCompare(b.nome));
  }
}
